"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDataField = exports.TicketConfig = exports.EventDetails = exports.Image = exports.ActivePeriod = exports.MenuItem = exports.Section = exports.Menu = void 0;
var Menu = /** @class */ (function () {
    function Menu(_a) {
        var id = _a.id, _b = _a.areaIds, areaIds = _b === void 0 ? [] : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.activePeriods, activePeriods = _d === void 0 ? {} : _d, _e = _a.config, config = _e === void 0 ? {} : _e, name = _a.name, _f = _a.sections, sections = _f === void 0 ? [] : _f, _g = _a.items, items = _g === void 0 ? {} : _g, menuType = _a.menuType, image = _a.image, _h = _a.description, description = _h === void 0 ? "" : _h, emailMessage = _a.emailMessage, orderDestinationId = _a.orderDestinationId, eventDetails = _a.eventDetails, ticketDetails = _a.ticketDetails, depositPerItem = _a.depositPerItem, defaultItemFee = _a.defaultItemFee, maxTotalItemFee = _a.maxTotalItemFee, stripeAccountId = _a.stripeAccountId, customDataFields = _a.customDataFields;
        this.id = id;
        this.areaIds = areaIds;
        this.active = active;
        this.activePeriods = activePeriods;
        this.config = config;
        this.name = name;
        this.sections = sections;
        this.items = items;
        this.menuType = menuType;
        this.image = image;
        this.description = description;
        this.emailMessage = emailMessage;
        this.orderDestinationId = orderDestinationId;
        this.eventDetails = eventDetails;
        this.ticketDetails = ticketDetails;
        this.depositPerItem = depositPerItem;
        this.defaultItemFee = defaultItemFee;
        this.maxTotalItemFee = maxTotalItemFee;
        this.stripeAccountId = stripeAccountId;
        this.customDataFields = customDataFields;
    }
    return Menu;
}());
exports.Menu = Menu;
var Section = /** @class */ (function () {
    function Section(_a) {
        var title = _a.title, sections = _a.sections, categories = _a.categories;
        this.title = title;
        this.sections = sections;
        this.categories = categories;
    }
    return Section;
}());
exports.Section = Section;
var MenuItem = /** @class */ (function () {
    function MenuItem(_a) {
        var itemId = _a.itemId, productId = _a.productId, section = _a.section, product = _a.product, createdDateTime = _a.createdDateTime, minimumOrderQuantity = _a.minimumOrderQuantity;
        this.itemId = itemId;
        this.productId = productId;
        this.section = section;
        this.product = product;
        this.createdDateTime = createdDateTime;
        this.minimumOrderQuantity = minimumOrderQuantity;
    }
    return MenuItem;
}());
exports.MenuItem = MenuItem;
var ActivePeriod = /** @class */ (function () {
    function ActivePeriod(_a) {
        var start = _a.start, end = _a.end;
        this.start = start;
        this.end = end;
    }
    return ActivePeriod;
}());
exports.ActivePeriod = ActivePeriod;
var Image = /** @class */ (function () {
    function Image(_a) {
        var coverUrl = _a.coverUrl;
        this.coverUrl = coverUrl;
    }
    return Image;
}());
exports.Image = Image;
var EventDetails = /** @class */ (function () {
    function EventDetails(_a) {
        var contactName = _a.contactName, contactEmail = _a.contactEmail, contactPhone = _a.contactPhone, eventDateTime = _a.eventDateTime, eventLocation = _a.eventLocation;
        this.contactName = contactName;
        this.contactEmail = contactEmail;
        this.contactPhone = contactPhone;
        this.eventDateTime = eventDateTime;
        this.eventLocation = eventLocation;
    }
    return EventDetails;
}());
exports.EventDetails = EventDetails;
var TicketConfig = /** @class */ (function () {
    function TicketConfig(_a) {
        var ticketNotes = _a.ticketNotes, _b = _a.generateTickets, generateTickets = _b === void 0 ? false : _b, _c = _a.ticketPerOrder, ticketPerOrder = _c === void 0 ? false : _c;
        this.ticketNotes = ticketNotes;
        this.generateTickets = generateTickets;
        this.ticketPerOrder = ticketPerOrder;
    }
    return TicketConfig;
}());
exports.TicketConfig = TicketConfig;
var CustomDataField = /** @class */ (function () {
    function CustomDataField(_a) {
        var id = _a.id, label = _a.label, _b = _a.isRequired, isRequired = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? 'text' : _c, _d = _a.includeInInvoice, includeInInvoice = _d === void 0 ? false : _d;
        this.id = id;
        this.label = label;
        this.isRequired = isRequired;
        this.type = type;
        this.includeInInvoice = includeInInvoice;
    }
    return CustomDataField;
}());
exports.CustomDataField = CustomDataField;
